import React, { useMemo, useState } from "react";
import { Navbar, Footer } from "../../Components";
import { useSubmitValuationRequestMutation } from "../../Services/AdvertiseService";
import "./style.css";

const TOTAL_STEPS = 8;

const PROPERTY_TYPE_CARDS = [
  {
    type: "Wohnung",
    icon: (
      <svg viewBox="0 0 60 60" fill="none" width="48" height="48" aria-hidden="true">
        <rect x="8" y="18" width="44" height="36" rx="1" stroke="currentColor" strokeWidth="1.4"/>
        <rect x="4" y="13" width="52" height="7" rx=".5" stroke="currentColor" strokeWidth="1.4"/>
        <rect x="42" y="6" width="6" height="9" rx=".5" stroke="currentColor" strokeWidth="1.2"/>
        <rect x="11" y="25" width="9" height="7" rx=".5" stroke="currentColor" strokeWidth="1.1"/>
        <rect x="25" y="25" width="9" height="7" rx=".5" stroke="currentColor" strokeWidth="1.1"/>
        <rect x="40" y="25" width="9" height="7" rx=".5" stroke="currentColor" strokeWidth="1.1"/>
        <rect x="11" y="37" width="9" height="7" rx=".5" stroke="currentColor" strokeWidth="1.1"/>
        <rect x="25" y="37" width="9" height="7" rx=".5" stroke="currentColor" strokeWidth="1.1"/>
        <rect x="40" y="37" width="9" height="7" rx=".5" stroke="currentColor" strokeWidth="1.1"/>
        <rect x="22" y="45" width="16" height="9" rx=".5" stroke="currentColor" strokeWidth="1.1"/>
        <circle cx="35" cy="50" r="1" fill="currentColor"/>
      </svg>
    ),
  },
  {
    type: "Haus",
    icon: (
      <svg viewBox="0 0 60 60" fill="none" width="48" height="48" aria-hidden="true">
        <rect x="8" y="32" width="44" height="24" rx="1" stroke="currentColor" strokeWidth="1.4"/>
        <path d="M4 33 L30 8 L56 33" stroke="currentColor" strokeWidth="1.4" strokeLinejoin="round"/>
        <rect x="40" y="14" width="7" height="12" rx=".5" stroke="currentColor" strokeWidth="1.2"/>
        <rect x="11" y="39" width="12" height="10" rx=".5" stroke="currentColor" strokeWidth="1.1"/>
        <line x1="17" y1="39" x2="17" y2="49" stroke="currentColor" strokeWidth=".7"/>
        <line x1="11" y1="44" x2="23" y2="44" stroke="currentColor" strokeWidth=".7"/>
        <rect x="37" y="39" width="12" height="10" rx=".5" stroke="currentColor" strokeWidth="1.1"/>
        <line x1="43" y1="39" x2="43" y2="49" stroke="currentColor" strokeWidth=".7"/>
        <line x1="37" y1="44" x2="49" y2="44" stroke="currentColor" strokeWidth=".7"/>
        <rect x="22" y="44" width="16" height="12" rx=".5" stroke="currentColor" strokeWidth="1.1"/>
        <circle cx="35" cy="51" r="1" fill="currentColor"/>
      </svg>
    ),
  },
  {
    type: "Grundstück",
    icon: (
      <svg viewBox="0 0 60 60" fill="none" width="48" height="48" aria-hidden="true">
        <path d="M30 52 L8 36 L30 20 L52 36 Z" stroke="currentColor" strokeWidth="1.4" strokeLinejoin="round"/>
        <line x1="19" y1="28" x2="41" y2="44" stroke="currentColor" strokeWidth=".6" strokeDasharray="3 2.5"/>
        <line x1="41" y1="28" x2="19" y2="44" stroke="currentColor" strokeWidth=".6" strokeDasharray="3 2.5"/>
        <circle cx="30" cy="28" r="7.5" stroke="currentColor" strokeWidth="1.3"/>
        <circle cx="30" cy="28" r="2.5" fill="currentColor"/>
        <line x1="30" y1="35.5" x2="30" y2="42" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round"/>
      </svg>
    ),
  },
  {
    type: "Gewerbe",
    icon: (
      <svg viewBox="0 0 60 60" fill="none" width="48" height="48" aria-hidden="true">
        <rect x="4" y="28" width="52" height="28" rx="1" stroke="currentColor" strokeWidth="1.4"/>
        <rect x="4" y="22" width="52" height="8" rx=".5" stroke="currentColor" strokeWidth="1.4"/>
        <rect x="4" y="14" width="22" height="10" rx=".5" stroke="currentColor" strokeWidth="1.2"/>
        <rect x="8" y="6" width="5" height="10" rx=".5" stroke="currentColor" strokeWidth="1.1"/>
        <rect x="15" y="4" width="5" height="12" rx=".5" stroke="currentColor" strokeWidth="1.1"/>
        <rect x="10" y="34" width="12" height="22" rx=".5" stroke="currentColor" strokeWidth="1.1"/>
        <rect x="28" y="34" width="12" height="22" rx=".5" stroke="currentColor" strokeWidth="1.1"/>
        <rect x="46" y="34" width="10" height="22" rx=".5" stroke="currentColor" strokeWidth="1.1"/>
      </svg>
    ),
  },
];

const CONDITION_OPTIONS = [
  {
    title: "Erstbezug / Neubau",
    desc: "Nie oder kaum bewohnt, keinerlei Mängel",
  },
  {
    title: "Gut gepflegt",
    desc: "Regelmäßig instand gehalten, zeitgemäßer Zustand",
  },
  {
    title: "Modernisierungsbedarf",
    desc: "Funktionsfähig, aber Renovierung sinnvoll",
  },
  {
    title: "Sanierungsbedürftig",
    desc: "Erheblicher Investitionsbedarf",
  },
];

const TIMELINE_OPTIONS = [
  {
    title: "Sofort",
    desc: "Ich suche aktiv einen Käufer",
  },
  {
    title: "Innerhalb von 6 Monaten",
    desc: "Konkrete Planung vorhanden",
  },
  {
    title: "In 6-18 Monaten",
    desc: "Mittelfristige Überlegung",
  },
  {
    title: "Nur Orientierung",
    desc: "Ich möchte nur den aktuellen Marktwert kennen",
  },
];

const OWNERSHIP_OPTIONS = [
  {
    title: "Ja - alleiniger Eigentümer",
    desc: "Die Immobilie gehört mir alleine",
  },
  {
    title: "Gemeinsam mit Partner / Familie",
    desc: "Gemeinschaftliches Eigentum",
  },
  {
    title: "Erbengemeinschaft",
    desc: "Immobilie wurde geerbt",
  },
  {
    title: "Noch nicht Eigentümer",
    desc: "Kaufinteressent oder Marktbeobachter",
  },
];

const FEATURES_LIVING = [
  "Einbauküche",
  "Keller",
  "Garage / Stellplatz",
  "Balkon / Terrasse",
  "Garten",
  "Aufzug",
  "Fußbodenheizung",
  "Photovoltaik / Solar",
  "Barrierefrei",
  "Denkmalschutz",
  "Smart Home",
];

const FEATURES_COMMERCIAL = [
  "Klimaanlage",
  "Lastenaufzug",
  "Rampe / Verladetor",
  "Stellplätze vorhanden",
  "Barrierefrei",
  "Doppelboden",
  "Denkmalschutz",
];

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const emptyForm = {
  propertyType: "",
  postalCode: "",
  city: "",
  street: "",
  livingAreaApartment: 80,
  livingAreaHouse: 150,
  plotAreaHouse: 500,
  plotAreaLand: 600,
  usableAreaCommercial: 200,
  roomsApartment: "",
  floor: "",
  floorsTotal: "",
  yearApartment: "",
  roomsHouse: "",
  yearHouse: "",
  storiesHouse: "",
  garageSpots: "",
  yearCommercial: "",
  parkingCommercial: "",
  zoning: "",
  developmentStatus: "",
  commercialType: "",
  condition: "",
  features: [],
  energyCertificate: "",
  rented: "",
  timeline: "",
  ownership: "",
  firstName: "",
  lastName: "",
  email: "",
  phone: "",
};

export default function BewertungPage() {
  const [step, setStep] = useState(1);
  const [form, setForm] = useState(emptyForm);
  const [submitError, setSubmitError] = useState("");

  const [submitValuationRequest, { isLoading: isSubmitting }] =
    useSubmitValuationRequestMutation();

  const estimate = useMemo(() => {
    if (form.propertyType !== "Wohnung" && form.propertyType !== "Haus") {
      return null;
    }

    const area =
      form.propertyType === "Wohnung"
        ? Number(form.livingAreaApartment) || 80
        : Number(form.livingAreaHouse) || 150;

    const year =
      form.propertyType === "Wohnung"
        ? Number(form.yearApartment) || 1990
        : Number(form.yearHouse) || 1985;

    const nowYear = new Date().getFullYear();
    const age = nowYear - year;
    let base = 2400;

    if (age < 5) base = 4800;
    else if (age < 15) base = 4100;
    else if (age < 30) base = 3400;
    else if (age < 50) base = 2900;

    return {
      min: Math.round((area * base * 0.88) / 1000) * 1000,
      max: Math.round((area * base * 1.12) / 1000) * 1000,
    };
  }, [form]);

  const progress = useMemo(() => {
    if (step > TOTAL_STEPS) return 100;
    return Math.round(((step - 1) / TOTAL_STEPS) * 100);
  }, [step]);

  const formatPriceRange = (value) => `${value.toLocaleString("de-DE")} EUR`;

  const updateForm = (key, value) => {
    setForm((prev) => ({ ...prev, [key]: value }));
  };

  const toggleFeature = (feature) => {
    setForm((prev) => {
      const exists = prev.features.includes(feature);
      return {
        ...prev,
        features: exists
          ? prev.features.filter((item) => item !== feature)
          : [...prev.features, feature],
      };
    });
  };

  const canGoNext = useMemo(() => {
    if (step === 1) return Boolean(form.propertyType);
    if (step === 2) {
      return form.postalCode.trim().length >= 4 && form.city.trim().length >= 2;
    }
    if (step === 4 && form.propertyType !== "Grundstück") {
      return Boolean(form.condition);
    }
    if (step === 6) return Boolean(form.timeline);
    if (step === 7) return Boolean(form.ownership);
    if (step === 8) {
      return (
        form.firstName.trim().length > 0 &&
        form.lastName.trim().length > 0 &&
        EMAIL_REGEX.test(form.email.trim()) &&
        !isSubmitting
      );
    }
    return true;
  }, [form, isSubmitting, step]);

  const getNextStep = () => {
    if (step === 3 && form.propertyType === "Grundstück") return 6;
    if (step === 5 && form.propertyType === "Grundstück") return 6;
    return step + 1;
  };

  const getPreviousStep = () => {
    if (step === 6 && form.propertyType === "Grundstück") return 3;
    return step - 1;
  };

  const goNext = () => {
    if (!canGoNext) return;
    setSubmitError("");
    setStep(getNextStep());
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const goBack = () => {
    setSubmitError("");
    setStep(getPreviousStep());
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const submitForm = async () => {
    if (!canGoNext) return;
    setSubmitError("");

    try {
      await submitValuationRequest({
        ...form,
        email: form.email.trim(),
        firstName: form.firstName.trim(),
        lastName: form.lastName.trim(),
        postalCode: form.postalCode.trim(),
        city: form.city.trim(),
        street: form.street.trim(),
        phone: form.phone.trim(),
        estimate,
      }).unwrap();
      setStep(9);
      window.scrollTo({ top: 0, behavior: "smooth" });
    } catch (error) {
      const message =
        error?.data?.message ||
        "Die Anfrage konnte nicht gesendet werden. Bitte versuchen Sie es erneut.";
      setSubmitError(Array.isArray(message) ? message.join(" ") : message);
    }
  };

  return (
    <>
      <Navbar />
      <div className="valuation-wrap">
        <div className="valuation-inner">
          <div className="valuation-page-title">
            <h1>Immobilienbewertung</h1>
            <p>Kostenlos &amp; unverbindlich – erhalten Sie Ihre persönliche Einschätzung in 24 Stunden.</p>
          </div>

          <div className="valuation-prog-track">
            <div className="valuation-prog-fill" style={{ width: `${progress}%` }} />
          </div>
          <div className="valuation-prog-info">
            <div className="valuation-prog-text">
              {step <= TOTAL_STEPS ? `Schritt ${step} von ${TOTAL_STEPS}` : ""}
            </div>
            <div className="valuation-prog-pct">{progress} %</div>
          </div>

          {step === 1 && (
            <div className="valuation-step">
              <h2 className="valuation-q">
                Was möchten Sie <span className="valuation-q-accent">bewerten?</span>
              </h2>
              <p className="valuation-sub">Immobilientyp auswählen</p>
              <div className="valuation-icon-grid">
                {PROPERTY_TYPE_CARDS.map(({ type, icon }) => (
                  <button
                    key={type}
                    className={`valuation-icon-card ${
                      form.propertyType === type ? "sel" : ""
                    }`}
                    onClick={() => updateForm("propertyType", type)}
                    type="button"
                  >
                    {icon}
                    <span className="valuation-icon-card-label">{type}</span>
                  </button>
                ))}
              </div>
              <div className="valuation-nav">
                <span />
                <button
                  className="valuation-btn-next"
                  onClick={goNext}
                  type="button"
                  disabled={!canGoNext}
                >
                  Weiter
                </button>
              </div>
            </div>
          )}

          {step === 2 && (
            <div className="valuation-step">
              <h2 className="valuation-q">
                Wo liegt <span className="valuation-q-accent">Ihre Immobilie?</span>
              </h2>
              <p className="valuation-sub">Die Lage ist ein zentraler Wertfaktor</p>
              <div className="valuation-row2">
                <div className="valuation-input-group">
                  <label className="valuation-lbl">Postleitzahl</label>
                  <input
                    className="valuation-field"
                    type="text"
                    value={form.postalCode}
                    onChange={(e) =>
                      updateForm(
                        "postalCode",
                        e.target.value.replace(/[^0-9]/g, "").slice(0, 5)
                      )
                    }
                    placeholder="70000"
                  />
                </div>
                <div className="valuation-input-group">
                  <label className="valuation-lbl">Ort</label>
                  <input
                    className="valuation-field"
                    type="text"
                    value={form.city}
                    onChange={(e) => updateForm("city", e.target.value)}
                    placeholder="Stuttgart"
                  />
                </div>
              </div>
              <div className="valuation-input-group">
                <label className="valuation-lbl">
                  Straße und Hausnummer <span className="valuation-lbl-opt">(optional)</span>
                </label>
                <input
                  className="valuation-field"
                  type="text"
                  value={form.street}
                  onChange={(e) => updateForm("street", e.target.value)}
                  placeholder="Musterstraße 12"
                />
              </div>
              <div className="valuation-nav">
                <button className="valuation-btn-back" onClick={goBack} type="button">
                  Zurück
                </button>
                <button
                  className="valuation-btn-next"
                  onClick={goNext}
                  type="button"
                  disabled={!canGoNext}
                >
                  Weiter
                </button>
              </div>
            </div>
          )}

          {step === 3 && (
            <div className="valuation-step">
              <h2 className="valuation-q">
                Eckdaten Ihrer <span className="valuation-q-accent">Immobilie</span>
              </h2>
              <p className="valuation-sub">Fläche und Details</p>

              {form.propertyType === "Wohnung" && (
                <>
                  <div className="valuation-slider-wrap">
                    <label className="valuation-lbl">Wohnfläche</label>
                    <div className="valuation-slider-val">
                      {Number(form.livingAreaApartment).toLocaleString("de-DE")} <span>m²</span>
                    </div>
                    <input
                      type="range"
                      min="20"
                      max="300"
                      step="5"
                      value={form.livingAreaApartment}
                      onChange={(e) =>
                        updateForm("livingAreaApartment", Number(e.target.value))
                      }
                    />
                    <div className="valuation-slider-range">
                      <span>20 m²</span>
                      <span>300 m²</span>
                    </div>
                  </div>
                  <div className="valuation-row2">
                    <div className="valuation-input-group">
                      <label className="valuation-lbl">Zimmeranzahl</label>
                      <input
                        className="valuation-field"
                        type="number"
                        min="1"
                        max="20"
                        value={form.roomsApartment}
                        onChange={(e) => updateForm("roomsApartment", e.target.value)}
                        placeholder="3"
                      />
                    </div>
                    <div className="valuation-input-group">
                      <label className="valuation-lbl">Stockwerk / Etage</label>
                      <input
                        className="valuation-field"
                        type="number"
                        min="0"
                        max="50"
                        value={form.floor}
                        onChange={(e) => updateForm("floor", e.target.value)}
                        placeholder="2"
                      />
                    </div>
                  </div>
                  <div className="valuation-row2">
                    <div className="valuation-input-group">
                      <label className="valuation-lbl">Baujahr</label>
                      <input
                        className="valuation-field"
                        type="number"
                        min="1800"
                        max="2100"
                        value={form.yearApartment}
                        onChange={(e) => updateForm("yearApartment", e.target.value)}
                        placeholder="1990"
                      />
                    </div>
                    <div className="valuation-input-group">
                      <label className="valuation-lbl">Etagen im Haus</label>
                      <input
                        className="valuation-field"
                        type="number"
                        min="1"
                        max="99"
                        value={form.floorsTotal}
                        onChange={(e) => updateForm("floorsTotal", e.target.value)}
                        placeholder="5"
                      />
                    </div>
                  </div>
                </>
              )}

              {form.propertyType === "Haus" && (
                <>
                  <div className="valuation-slider-wrap">
                    <label className="valuation-lbl">Wohnfläche</label>
                    <div className="valuation-slider-val">
                      {Number(form.livingAreaHouse).toLocaleString("de-DE")} <span>m²</span>
                    </div>
                    <input
                      type="range"
                      min="40"
                      max="600"
                      step="10"
                      value={form.livingAreaHouse}
                      onChange={(e) => updateForm("livingAreaHouse", Number(e.target.value))}
                    />
                    <div className="valuation-slider-range">
                      <span>40 m²</span>
                      <span>600 m²</span>
                    </div>
                  </div>

                  <div className="valuation-slider-wrap">
                    <label className="valuation-lbl">Grundstücksfläche</label>
                    <div className="valuation-slider-val">
                      {Number(form.plotAreaHouse).toLocaleString("de-DE")} <span>m²</span>
                    </div>
                    <input
                      type="range"
                      min="100"
                      max="5000"
                      step="50"
                      value={form.plotAreaHouse}
                      onChange={(e) => updateForm("plotAreaHouse", Number(e.target.value))}
                    />
                    <div className="valuation-slider-range">
                      <span>100 m²</span>
                      <span>5.000 m²</span>
                    </div>
                  </div>

                  <div className="valuation-row2">
                    <div className="valuation-input-group">
                      <label className="valuation-lbl">Zimmeranzahl</label>
                      <input
                        className="valuation-field"
                        type="number"
                        min="1"
                        max="30"
                        value={form.roomsHouse}
                        onChange={(e) => updateForm("roomsHouse", e.target.value)}
                        placeholder="5"
                      />
                    </div>
                    <div className="valuation-input-group">
                      <label className="valuation-lbl">Baujahr</label>
                      <input
                        className="valuation-field"
                        type="number"
                        min="1800"
                        max="2100"
                        value={form.yearHouse}
                        onChange={(e) => updateForm("yearHouse", e.target.value)}
                        placeholder="1985"
                      />
                    </div>
                  </div>

                  <div className="valuation-row2">
                    <div className="valuation-input-group">
                      <label className="valuation-lbl">Anzahl Vollgeschosse</label>
                      <input
                        className="valuation-field"
                        type="number"
                        min="1"
                        max="10"
                        value={form.storiesHouse}
                        onChange={(e) => updateForm("storiesHouse", e.target.value)}
                        placeholder="2"
                      />
                    </div>
                    <div className="valuation-input-group">
                      <label className="valuation-lbl">Garage / Stellplätze</label>
                      <input
                        className="valuation-field"
                        type="number"
                        min="0"
                        max="20"
                        value={form.garageSpots}
                        onChange={(e) => updateForm("garageSpots", e.target.value)}
                        placeholder="1"
                      />
                    </div>
                  </div>
                </>
              )}

              {form.propertyType === "Grundstück" && (
                <>
                  <div className="valuation-info-box">
                    Bei einem unbebauten Grundstück sind Lage, Größe und Bebaubarkeit die entscheidenden Wertfaktoren.
                  </div>

                  <div className="valuation-slider-wrap">
                    <label className="valuation-lbl">Grundstücksfläche</label>
                    <div className="valuation-slider-val">
                      {Number(form.plotAreaLand).toLocaleString("de-DE")} <span>m²</span>
                    </div>
                    <input
                      type="range"
                      min="100"
                      max="10000"
                      step="100"
                      value={form.plotAreaLand}
                      onChange={(e) => updateForm("plotAreaLand", Number(e.target.value))}
                    />
                    <div className="valuation-slider-range">
                      <span>100 m²</span>
                      <span>10.000 m²</span>
                    </div>
                  </div>

                  <div className="valuation-input-group">
                    <label className="valuation-lbl">Bebauungsart</label>
                    <div className="valuation-chips">
                      {[
                        "Wohnbebauung",
                        "Gewerbliche Nutzung",
                        "Gemischte Nutzung",
                        "Noch nicht festgelegt",
                      ].map((item) => (
                        <button
                          key={item}
                          type="button"
                          className={`valuation-chip ${form.zoning === item ? "sel" : ""}`}
                          onClick={() => updateForm("zoning", item)}
                        >
                          {item}
                        </button>
                      ))}
                    </div>
                  </div>

                  <div className="valuation-input-group">
                    <label className="valuation-lbl">Erschlossen?</label>
                    <div className="valuation-chips">
                      {[
                        "Ja - voll erschlossen",
                        "Teilweise erschlossen",
                        "Nein / Unbekannt",
                      ].map((item) => (
                        <button
                          key={item}
                          type="button"
                          className={`valuation-chip ${
                            form.developmentStatus === item ? "sel" : ""
                          }`}
                          onClick={() => updateForm("developmentStatus", item)}
                        >
                          {item}
                        </button>
                      ))}
                    </div>
                  </div>
                </>
              )}

              {form.propertyType === "Gewerbe" && (
                <>
                  <div className="valuation-slider-wrap">
                    <label className="valuation-lbl">Nutzfläche</label>
                    <div className="valuation-slider-val">
                      {Number(form.usableAreaCommercial).toLocaleString("de-DE")} <span>m²</span>
                    </div>
                    <input
                      type="range"
                      min="20"
                      max="2000"
                      step="20"
                      value={form.usableAreaCommercial}
                      onChange={(e) =>
                        updateForm("usableAreaCommercial", Number(e.target.value))
                      }
                    />
                    <div className="valuation-slider-range">
                      <span>20 m²</span>
                      <span>2.000 m²</span>
                    </div>
                  </div>

                  <div className="valuation-row2">
                    <div className="valuation-input-group">
                      <label className="valuation-lbl">Baujahr</label>
                      <input
                        className="valuation-field"
                        type="number"
                        min="1800"
                        max="2100"
                        value={form.yearCommercial}
                        onChange={(e) => updateForm("yearCommercial", e.target.value)}
                        placeholder="1995"
                      />
                    </div>
                    <div className="valuation-input-group">
                      <label className="valuation-lbl">Anzahl Stellplätze</label>
                      <input
                        className="valuation-field"
                        type="number"
                        min="0"
                        max="99"
                        value={form.parkingCommercial}
                        onChange={(e) => updateForm("parkingCommercial", e.target.value)}
                        placeholder="5"
                      />
                    </div>
                  </div>

                  <div className="valuation-input-group">
                    <label className="valuation-lbl">Gewerbeart</label>
                    <div className="valuation-chips">
                      {[
                        "Büro / Praxis",
                        "Einzelhandel",
                        "Lager / Halle",
                        "Gastronomie",
                        "Produktion",
                        "Sonstiges",
                      ].map((item) => (
                        <button
                          key={item}
                          type="button"
                          className={`valuation-chip ${
                            form.commercialType === item ? "sel" : ""
                          }`}
                          onClick={() => updateForm("commercialType", item)}
                        >
                          {item}
                        </button>
                      ))}
                    </div>
                  </div>
                </>
              )}

              <div className="valuation-nav">
                <button className="valuation-btn-back" onClick={goBack} type="button">
                  Zurück
                </button>
                <button className="valuation-btn-next" onClick={goNext} type="button">
                  Weiter
                </button>
              </div>
            </div>
          )}

          {step === 4 && form.propertyType !== "Grundstück" && (
            <div className="valuation-step">
              <h2 className="valuation-q">
                Welchen <span className="valuation-q-accent">Zustand</span> hat die Immobilie?
              </h2>
              <p className="valuation-sub">Ihr Eindruck - kein Gutachten nötig</p>
              <div className="valuation-big-select">
                {CONDITION_OPTIONS.map((option, index) => (
                  <button
                    key={option.title}
                    className={`valuation-big-opt ${
                      form.condition === option.title ? "sel" : ""
                    }`}
                    onClick={() => updateForm("condition", option.title)}
                    type="button"
                  >
                    <div className="valuation-big-opt-num">
                      {String(index + 1).padStart(2, "0")}
                    </div>
                    <div className="valuation-big-opt-body">
                      <div className="valuation-big-opt-title">{option.title}</div>
                      <div className="valuation-big-opt-desc">{option.desc}</div>
                    </div>
                  </button>
                ))}
              </div>
              <div className="valuation-nav">
                <button className="valuation-btn-back" onClick={goBack} type="button">
                  Zurück
                </button>
                <button
                  className="valuation-btn-next"
                  onClick={goNext}
                  type="button"
                  disabled={!canGoNext}
                >
                  Weiter
                </button>
              </div>
            </div>
          )}

          {step === 5 && form.propertyType !== "Grundstück" && (
            <div className="valuation-step">
              <h2 className="valuation-q">
                Was ist <span className="valuation-q-accent">vorhanden?</span>
              </h2>
              <p className="valuation-sub">Mehrfachauswahl möglich</p>

              <div className="valuation-chips">
                {(form.propertyType === "Gewerbe"
                  ? FEATURES_COMMERCIAL
                  : FEATURES_LIVING
                ).map((item) => (
                  <button
                    key={item}
                    type="button"
                    className={`valuation-chip ${form.features.includes(item) ? "sel" : ""}`}
                    onClick={() => toggleFeature(item)}
                  >
                    {item}
                  </button>
                ))}
              </div>

              {form.propertyType !== "Gewerbe" && (
                <>
                  <div className="valuation-input-group section-sep">
                    <label className="valuation-lbl">Energieausweis vorhanden?</label>
                    <div className="valuation-chips">
                      {["Ja", "Nein", "Nicht vorhanden"].map((item) => (
                        <button
                          key={item}
                          type="button"
                          className={`valuation-chip ${
                            form.energyCertificate === item ? "sel" : ""
                          }`}
                          onClick={() => updateForm("energyCertificate", item)}
                        >
                          {item}
                        </button>
                      ))}
                    </div>
                  </div>

                  <div className="valuation-input-group">
                    <label className="valuation-lbl">Aktuell vermietet?</label>
                    <div className="valuation-chips">
                      {["Ja", "Nein / Selbstgenutzt"].map((item) => (
                        <button
                          key={item}
                          type="button"
                          className={`valuation-chip ${form.rented === item ? "sel" : ""}`}
                          onClick={() => updateForm("rented", item)}
                        >
                          {item}
                        </button>
                      ))}
                    </div>
                  </div>
                </>
              )}

              {form.propertyType === "Gewerbe" && (
                <div className="valuation-input-group section-sep">
                  <label className="valuation-lbl">Aktuell vermietet?</label>
                  <div className="valuation-chips">
                    {["Ja", "Nein / Leerstand"].map((item) => (
                      <button
                        key={item}
                        type="button"
                        className={`valuation-chip ${form.rented === item ? "sel" : ""}`}
                        onClick={() => updateForm("rented", item)}
                      >
                        {item}
                      </button>
                    ))}
                  </div>
                </div>
              )}

              <div className="valuation-nav">
                <button className="valuation-btn-back" onClick={goBack} type="button">
                  Zurück
                </button>
                <button className="valuation-btn-next" onClick={goNext} type="button">
                  Weiter
                </button>
              </div>
            </div>
          )}

          {step === 6 && (
            <div className="valuation-step">
              <h2 className="valuation-q">
                Wann planen Sie <span className="valuation-q-accent">zu verkaufen?</span>
              </h2>
              <p className="valuation-sub">Hilft uns, Sie optimal zu unterstützen</p>
              <div className="valuation-big-select">
                {TIMELINE_OPTIONS.map((option, index) => (
                  <button
                    key={option.title}
                    className={`valuation-big-opt ${
                      form.timeline === option.title ? "sel" : ""
                    }`}
                    onClick={() => updateForm("timeline", option.title)}
                    type="button"
                  >
                    <div className="valuation-big-opt-num">
                      {String(index + 1).padStart(2, "0")}
                    </div>
                    <div className="valuation-big-opt-body">
                      <div className="valuation-big-opt-title">{option.title}</div>
                      <div className="valuation-big-opt-desc">{option.desc}</div>
                    </div>
                  </button>
                ))}
              </div>
              <div className="valuation-nav">
                <button className="valuation-btn-back" onClick={goBack} type="button">
                  Zurück
                </button>
                <button
                  className="valuation-btn-next"
                  onClick={goNext}
                  type="button"
                  disabled={!canGoNext}
                >
                  Weiter
                </button>
              </div>
            </div>
          )}

          {step === 7 && (
            <div className="valuation-step">
              <h2 className="valuation-q">
                Sind Sie <span className="valuation-q-accent">Eigentümer?</span>
              </h2>
              <p className="valuation-sub">
                Nur Eigentümer erhalten eine vollständige Bewertung
              </p>
              <div className="valuation-big-select">
                {OWNERSHIP_OPTIONS.map((option, index) => (
                  <button
                    key={option.title}
                    className={`valuation-big-opt ${
                      form.ownership === option.title ? "sel" : ""
                    }`}
                    onClick={() => updateForm("ownership", option.title)}
                    type="button"
                  >
                    <div className="valuation-big-opt-num">
                      {String(index + 1).padStart(2, "0")}
                    </div>
                    <div className="valuation-big-opt-body">
                      <div className="valuation-big-opt-title">{option.title}</div>
                      <div className="valuation-big-opt-desc">{option.desc}</div>
                    </div>
                  </button>
                ))}
              </div>
              <div className="valuation-nav">
                <button className="valuation-btn-back" onClick={goBack} type="button">
                  Zurück
                </button>
                <button
                  className="valuation-btn-next"
                  onClick={goNext}
                  type="button"
                  disabled={!canGoNext}
                >
                  Weiter
                </button>
              </div>
            </div>
          )}

          {step === 8 && (
            <div className="valuation-step">
              <h2 className="valuation-q">
                Wohin senden wir <span className="valuation-q-accent">Ihre Bewertung?</span>
              </h2>
              <p className="valuation-sub">Kostenlos und unverbindlich</p>

              {estimate && (
                <div className="valuation-estimate-peek">
                  <div>
                    <div className="valuation-ep-label">Erste Einschätzung</div>
                    <div className="valuation-ep-val">
                      {formatPriceRange(estimate.min)} - {formatPriceRange(estimate.max)}
                    </div>
                  </div>
                  <div className="valuation-ep-note">Präzise Bewertung folgt per E-Mail</div>
                </div>
              )}

              <div className="valuation-row2">
                <div className="valuation-input-group">
                  <label className="valuation-lbl">Vorname</label>
                  <input
                    className="valuation-field"
                    type="text"
                    value={form.firstName}
                    onChange={(e) => updateForm("firstName", e.target.value)}
                    placeholder="Max"
                  />
                </div>
                <div className="valuation-input-group">
                  <label className="valuation-lbl">Nachname</label>
                  <input
                    className="valuation-field"
                    type="text"
                    value={form.lastName}
                    onChange={(e) => updateForm("lastName", e.target.value)}
                    placeholder="Mustermann"
                  />
                </div>
              </div>

              <div className="valuation-input-group">
                <label className="valuation-lbl">E-Mail-Adresse</label>
                <input
                  className="valuation-field"
                  type="email"
                  value={form.email}
                  onChange={(e) => updateForm("email", e.target.value)}
                  placeholder="max@beispiel.de"
                />
              </div>

              <div className="valuation-input-group">
                <label className="valuation-lbl">
                  Telefon <span className="valuation-lbl-opt">(optional)</span>
                </label>
                <input
                  className="valuation-field"
                  type="tel"
                  value={form.phone}
                  onChange={(e) => updateForm("phone", e.target.value)}
                  placeholder="+49 711 ..."
                />
              </div>

              <div className="valuation-trust">
                <div className="valuation-trust-item">100 Prozent kostenlos und unverbindlich</div>
                <div className="valuation-trust-item">DSGVO-konform</div>
                <div className="valuation-trust-item">Antwort innerhalb 24 h</div>
              </div>

              {submitError && <p className="valuation-error">{submitError}</p>}

              <div className="valuation-nav">
                <button className="valuation-btn-back" onClick={goBack} type="button">
                  Zurück
                </button>
                <button
                  className="valuation-btn-next"
                  type="button"
                  onClick={submitForm}
                  disabled={!canGoNext}
                >
                  {isSubmitting ? "Wird gesendet..." : "Bewertung anfordern"}
                </button>
              </div>

              <p className="valuation-disclaimer">
                Mit dem Absenden stimmen Sie der Kontaktaufnahme per E-Mail zu (jederzeit widerrufbar).
              </p>
            </div>
          )}

          {step === 9 && (
            <div className="valuation-step">
              <div className="valuation-confirm">
                <div className="valuation-confirm-ring">OK</div>
                <h2 className="valuation-confirm-title">Anfrage eingegangen.</h2>
                <p className="valuation-confirm-sub">
                  Wir haben alle Angaben erhalten und erstellen Ihre persönliche
                  Immobilienbewertung. Sie erhalten diese innerhalb von 24 Stunden
                  per E-Mail.
                </p>
                <div className="valuation-confirm-hr" />
                <div className="valuation-confirm-steps">
                  <div className="valuation-confirm-step">
                    1. Bestätigungs-E-Mail erhalten
                  </div>
                  <div className="valuation-confirm-step">
                    2. Bewertung erhalten (innerhalb von 24 Stunden)
                  </div>
                  <div className="valuation-confirm-step">
                    3. Auf Wunsch: Makler-Empfehlung in Ihrer Region
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      <Footer />
    </>
  );
}
